"use client";
import React from "react";
import { useNavigation } from "react-navi";
import { motion } from "framer-motion";

export default function Homepage() {
  const nav = useNavigation();

  const balls = [
    { x: 100, y: 200, size: 180, color: "rgba(99,102,241,0.2)", duration: 12 },
    { x: 600, y: 400, size: 240, color: "rgba(165,180,252,0.25)", duration: 18 },
    { x: 1000, y: 150, size: 200, color: "rgba(59,130,246,0.25)", duration: 15 },
  ];

  return (
    <div className="relative overflow-hidden min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-indigo-100 py-12">
      {/* Animated Background SVG Balls */}
      <div className="absolute inset-0 overflow-hidden">
        {balls.map((ball, index) => (
          <motion.div
            key={index}
            className="absolute rounded-full blur-lg"
            style={{
              background: ball.color,
              width: ball.size,
              height: ball.size,
              top: ball.y,
              left: ball.x,
            }}
            animate={{
              x: [ball.x, ball.x + 60, ball.x - 40, ball.x],
              y: [ball.y, ball.y - 40, ball.y + 50, ball.y],
            }}
            transition={{
              duration: ball.duration,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {/* Foreground Content */}
      <div className="relative z-10 mx-auto max-w-5xl px-6 lg:px-12">
        <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl p-8 lg:p-14 border border-indigo-100">
          {/* Logo */}
          <div className="text-center">
            <img
              src="/images/fosarica-logo.png"
              alt="FoSaRiCa Logo"
              className="mx-auto h-36 w-auto mb-4 drop-shadow-md"
            />
            <h2 className="text-2xl font-bold text-indigo-700 mb-3">
              About FoSaRiCa
            </h2>
          </div>

          {/* About Section */}
          <p className="text-gray-700 text-justify leading-relaxed text-[15px]">
            <strong>FoSaRiCa (Food Safety Risk Calculator)</strong> has been designed
            to suit Indian users and is a simple tool for ranking the risks
            associated with different foods by considering the interplay of
            factors that contribute to foodborne disease. It can also be used to
            explore the effect of different risk-reduction strategies or the
            extent of change required to bring about a desired reduction in
            food risk. It can be used by risk managers, researchers, students,
            and others without extensive experience in risk modelling.
          </p>

          {/* Instructions */}
          <div className="mt-10">
            <h3 className="text-xl font-semibold text-indigo-700 mb-4 text-center">
              Instructions for Using FoSaRiCa
            </h3>
            <ol className="list-decimal list-inside text-gray-700 text-[15px] space-y-3 leading-relaxed">
              <li>
                Enter the basic details of the food for which the risk rank is
                intended to be calculated.
              </li>
              <li>
                FoSaRiCa contains eleven compulsory questions. The answers are
                to be selected from the drop-down options. The numbers in
                brackets indicate the underlying values used in the
                calculations.
              </li>
              <li>
                For questions with the option <em>“Other”</em>, users can enter
                custom values. Note that the system will not verify the accuracy
                of these inputs.
              </li>
              <li>
                Click the <strong>“Calculate”</strong> button to generate and
                view results on the page.
              </li>
              <li>
                Option is available to save results in PDF format.
              </li>
            </ol>
          </div>

          {/* CTA Button */}
          <div className="mt-10 flex justify-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => nav.navigate("/calculator")}
              className="rounded-md bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-md hover:bg-indigo-500 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            >
              Go to Calculator
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
}
